import { render, staticRenderFns } from "./RedHeaderBar.vue?vue&type=template&id=61c0e172"
import script from "./RedHeaderBar.vue?vue&type=script&lang=js"
export * from "./RedHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./RedHeaderBar.vue?vue&type=style&index=0&id=61c0e172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports